// extracted by mini-css-extract-plugin
export var downArrow = "_ap-0";
export var infoTooltipIcon = "_ap-3";
export var label = "_ap-1";
export var optionCard = "_ap-4";
export var upArrow = "_ap-2";